<ng-container>
    <div [innerHtml]="section.text | safeHtml"></div>
</ng-container>